import {SDynamicComponent} from "@/components/dto/SDynamicComponent";

export class ObjUtils {

    static prop(obj: any, key: string): any {
        return obj[key];
    }

    static pushComponent(obj: SDynamicComponent[], uid: string, addComponent: SDynamicComponent[]){
        for (let c of obj) {
            if(c.component.uid === uid && c.data.body != undefined){
                c.data.body.push(...addComponent);
            }else{
                if(c.data.body != undefined) {
                    this.pushComponent(c.data.body, uid, addComponent);
                }
            }
        }
        return;
    }

    static removeComponent(obj: SDynamicComponent[], uid: string){
        let delIndex = obj.findIndex(item => item.component.uid === uid);
        if(delIndex !== -1){
            obj.splice(delIndex,1);
            return;
        }
        for (let c of obj) {
            if(c.data.body != undefined) {
                this.removeComponent(c.data.body, uid);
            }
        }
        return;
    }

    static parseJsonString(str: string): any{
        return JSON.parse(str, this.tryParseJsonString)
    }

    private static tryParseJsonString(key: any, value: any) : any {
        if (typeof value === 'string') {
            if (value.length > 0 && (value.startsWith('{') || value.startsWith('"'))) {
                // The value looks like escaped JSON in string -> parse it recursively
                return JSON.parse(value, this.tryParseJsonString);
            }
        }
        return value;
    }

    static deepCopy <T>(target: T): T  {
        if (target === null) {
            return target;
        }
        if (target instanceof Date) {
            return new Date(target.getTime()) as any;
        }
        if (target instanceof Array) {
            const cp = [] as any[];
            (target as any[]).forEach((v) => { cp.push(v); });
            return cp.map((n: any) => this.deepCopy<any>(n)) as any;
        }
        if (typeof target === 'object' && target !== {}) {
            const cp = { ...(target as { [key: string]: any }) } as { [key: string]: any };
            Object.keys(cp).forEach(k => {
                cp[k] = this.deepCopy<any>(cp[k]);
            });
            return cp as T;
        }
        return target;
    };

    static assign(source: any, target: any, condition?: any) {
        Object.keys(source).map((key: any) => {
            if(condition && condition[key] && target.hasOwnProperty(key)){
                target[key] = source[key];
            }else if((condition && !condition[key] || !condition) && target.hasOwnProperty(key)){
                if(source[key] === "" || source[key] === null || (condition && condition[key] !== undefined && !condition[key])){
                    target[key] = null;
                }else {
                    target[key] = source[key];
                }
            }
        });
        return target;
    }
}

